let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8lD9V")).then(() => parcelRequire('41dWS'));